// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.SelectAll: ImageVector
    get() = COUIIcons.Regular.SelectAll

val COUIIcons.Light.SelectAll: ImageVector
    get() {
        if (_selectallLight != null) return _selectallLight!!
        _selectallLight = ImageVector.Builder(
            name = "SelectAll.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1159.2f,
            viewportHeight = 1159.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1159.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(376.7f, 1003.7f),
                        PathNode.LineTo(244.9f, 871.0f),
                        PathNode.QuadTo(240.1f, 866.2f, 236.7f, 866.1f),
                        PathNode.QuadTo(233.2f, 866.1f, 229.2f, 871.0f),
                        PathNode.LineTo(167.1f, 931.4f),
                        PathNode.QuadTo(162.0f, 937.3f, 154.5f, 937.9f),
                        PathNode.QuadTo(147.0f, 938.5f, 140.9f, 932.3f),
                        PathNode.LineTo(125.9f, 917.4f),
                        PathNode.QuadTo(118.0f, 910.2f, 118.9f, 903.2f),
                        PathNode.QuadTo(119.9f, 896.3f, 125.0f, 891.2f),
                        PathNode.LineTo(209.4f, 806.8f),
                        PathNode.QuadTo(223.3f, 792.9f, 237.1f, 793.4f),
                        PathNode.QuadTo(250.9f, 793.8f, 267.7f, 809.6f),
                        PathNode.LineTo(419.8f, 961.7f),
                        PathNode.QuadTo(426.8f, 969.6f, 427.3f, 976.8f),
                        PathNode.QuadTo(427.8f, 984.0f, 420.7f, 990.9f),
                        PathNode.LineTo(405.9f, 1005.8f),
                        PathNode.QuadTo(398.8f, 1011.9f, 390.8f, 1010.9f),
                        PathNode.QuadTo(382.9f, 1009.9f, 376.7f, 1003.7f),
                        PathNode.Close,
                        PathNode.MoveTo(1041.3f, 550.4f),
                        PathNode.VerticalTo(572.2f),
                        PathNode.QuadTo(1041.3f, 582.3f, 1035.3f, 586.8f),
                        PathNode.QuadTo(1029.3f, 591.3f, 1021.0f, 591.3f),
                        PathNode.HorizontalTo(520.8f),
                        PathNode.QuadTo(512.7f, 591.3f, 506.6f, 586.3f),
                        PathNode.QuadTo(500.5f, 581.3f, 500.5f, 573.2f),
                        PathNode.VerticalTo(551.3f),
                        PathNode.QuadTo(500.5f, 541.3f, 506.1f, 536.3f),
                        PathNode.QuadTo(511.7f, 531.3f, 520.8f, 531.3f),
                        PathNode.HorizontalTo(1021.0f),
                        PathNode.QuadTo(1029.3f, 531.3f, 1035.3f, 535.8f),
                        PathNode.QuadTo(1041.3f, 540.3f, 1041.3f, 550.4f),
                        PathNode.Close,
                        PathNode.MoveTo(1041.3f, 872.3f),
                        PathNode.VerticalTo(894.1f),
                        PathNode.QuadTo(1041.3f, 904.2f, 1035.3f, 908.7f),
                        PathNode.QuadTo(1029.3f, 913.2f, 1021.0f, 913.2f),
                        PathNode.HorizontalTo(520.8f),
                        PathNode.QuadTo(512.7f, 913.2f, 506.6f, 908.2f),
                        PathNode.QuadTo(500.5f, 903.2f, 500.5f, 895.1f),
                        PathNode.VerticalTo(873.2f),
                        PathNode.QuadTo(500.5f, 863.1f, 506.1f, 858.2f),
                        PathNode.QuadTo(511.7f, 853.2f, 520.8f, 853.2f),
                        PathNode.HorizontalTo(1021.0f),
                        PathNode.QuadTo(1029.3f, 853.2f, 1035.3f, 857.7f),
                        PathNode.QuadTo(1041.3f, 862.2f, 1041.3f, 872.3f),
                        PathNode.Close,
                        PathNode.MoveTo(1041.3f, 227.6f),
                        PathNode.VerticalTo(249.4f),
                        PathNode.QuadTo(1041.3f, 259.5f, 1035.7f, 263.6f),
                        PathNode.QuadTo(1030.1f, 267.6f, 1021.0f, 267.6f),
                        PathNode.HorizontalTo(520.8f),
                        PathNode.QuadTo(511.8f, 267.6f, 506.2f, 263.1f),
                        PathNode.QuadTo(500.5f, 258.5f, 500.5f, 249.5f),
                        PathNode.VerticalTo(227.7f),
                        PathNode.QuadTo(500.5f, 218.4f, 506.1f, 213.4f),
                        PathNode.QuadTo(511.7f, 208.5f, 520.8f, 208.5f),
                        PathNode.HorizontalTo(1021.0f),
                        PathNode.QuadTo(1029.3f, 208.5f, 1035.3f, 213.0f),
                        PathNode.QuadTo(1041.3f, 217.5f, 1041.3f, 227.6f),
                        PathNode.Close,
                        PathNode.MoveTo(376.7f, 682.0f),
                        PathNode.LineTo(244.9f, 549.2f),
                        PathNode.QuadTo(240.1f, 544.4f, 236.7f, 544.4f),
                        PathNode.QuadTo(233.2f, 544.3f, 229.2f, 549.2f),
                        PathNode.LineTo(167.1f, 610.4f),
                        PathNode.QuadTo(162.0f, 615.5f, 154.5f, 616.1f),
                        PathNode.QuadTo(147.0f, 616.7f, 140.9f, 610.5f),
                        PathNode.LineTo(125.9f, 595.6f),
                        PathNode.QuadTo(118.0f, 588.5f, 118.9f, 581.5f),
                        PathNode.QuadTo(119.9f, 574.5f, 125.0f, 569.4f),
                        PathNode.LineTo(209.4f, 485.0f),
                        PathNode.QuadTo(223.3f, 471.1f, 237.1f, 471.6f),
                        PathNode.QuadTo(250.9f, 472.1f, 267.7f, 487.9f),
                        PathNode.LineTo(419.8f, 640.8f),
                        PathNode.QuadTo(426.8f, 647.8f, 427.3f, 655.0f),
                        PathNode.QuadTo(427.8f, 662.2f, 420.7f, 669.1f),
                        PathNode.LineTo(405.9f, 684.0f),
                        PathNode.QuadTo(398.8f, 690.1f, 390.8f, 689.1f),
                        PathNode.QuadTo(382.9f, 688.1f, 376.7f, 682.0f),
                        PathNode.Close,
                        PathNode.MoveTo(376.7f, 358.2f),
                        PathNode.LineTo(244.9f, 225.4f),
                        PathNode.QuadTo(240.1f, 220.6f, 236.7f, 220.6f),
                        PathNode.QuadTo(233.2f, 220.5f, 229.2f, 225.4f),
                        PathNode.LineTo(167.1f, 286.7f),
                        PathNode.QuadTo(162.0f, 291.7f, 154.5f, 292.3f),
                        PathNode.QuadTo(147.0f, 292.9f, 140.9f, 286.8f),
                        PathNode.LineTo(125.9f, 271.8f),
                        PathNode.QuadTo(118.0f, 264.7f, 118.9f, 257.7f),
                        PathNode.QuadTo(119.9f, 250.7f, 125.0f, 245.6f),
                        PathNode.LineTo(209.4f, 161.2f),
                        PathNode.QuadTo(223.3f, 147.3f, 237.1f, 147.8f),
                        PathNode.QuadTo(250.9f, 148.3f, 267.7f, 164.1f),
                        PathNode.LineTo(419.8f, 317.0f),
                        PathNode.QuadTo(426.8f, 324.0f, 427.3f, 331.2f),
                        PathNode.QuadTo(427.8f, 338.5f, 420.7f, 345.3f),
                        PathNode.LineTo(405.9f, 360.2f),
                        PathNode.QuadTo(398.8f, 366.3f, 390.8f, 365.3f),
                        PathNode.QuadTo(382.9f, 364.3f, 376.7f, 358.2f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _selectallLight!!
    }

private var _selectallLight: ImageVector? = null

val COUIIcons.Normal.SelectAll: ImageVector
    get() {
        if (_selectallNormal != null) return _selectallNormal!!
        _selectallNormal = ImageVector.Builder(
            name = "SelectAll.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1164.1f,
            viewportHeight = 1164.1f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1164.1f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(370.2f, 1009.6f),
                        PathNode.LineTo(250.9f, 889.3f),
                        PathNode.QuadTo(246.1f, 884.5f, 242.0f, 884.1f),
                        PathNode.QuadTo(237.8f, 883.7f, 232.5f, 889.3f),
                        PathNode.LineTo(182.8f, 938.6f),
                        PathNode.QuadTo(175.6f, 945.9f, 166.1f, 947.1f),
                        PathNode.QuadTo(156.5f, 948.4f, 147.6f, 939.5f),
                        PathNode.LineTo(128.5f, 920.5f),
                        PathNode.QuadTo(118.5f, 910.6f, 119.4f, 901.5f),
                        PathNode.QuadTo(120.4f, 892.4f, 127.6f, 885.2f),
                        PathNode.LineTo(207.7f, 805.0f),
                        PathNode.QuadTo(225.1f, 787.7f, 242.1f, 788.2f),
                        PathNode.QuadTo(259.0f, 788.7f, 279.2f, 807.9f),
                        PathNode.LineTo(426.4f, 955.1f),
                        PathNode.QuadTo(435.5f, 964.3f, 436.0f, 975.0f),
                        PathNode.QuadTo(436.5f, 985.7f, 427.4f, 994.0f),
                        PathNode.LineTo(409.1f, 1012.3f),
                        PathNode.QuadTo(399.2f, 1021.2f, 389.2f, 1019.8f),
                        PathNode.QuadTo(379.2f, 1018.5f, 370.2f, 1009.6f),
                        PathNode.Close,
                        PathNode.MoveTo(1045.7f, 552.2f),
                        PathNode.VerticalTo(579.5f),
                        PathNode.QuadTo(1045.7f, 593.1f, 1037.9f, 599.0f),
                        PathNode.QuadTo(1030.2f, 604.9f, 1017.8f, 604.9f),
                        PathNode.HorizontalTo(532.3f),
                        PathNode.QuadTo(520.7f, 604.9f, 512.5f, 598.5f),
                        PathNode.QuadTo(504.4f, 592.1f, 504.4f, 580.5f),
                        PathNode.VerticalTo(553.1f),
                        PathNode.QuadTo(504.4f, 539.6f, 512.1f, 533.2f),
                        PathNode.QuadTo(519.7f, 526.9f, 532.3f, 526.9f),
                        PathNode.HorizontalTo(1017.8f),
                        PathNode.QuadTo(1030.2f, 526.9f, 1037.9f, 532.8f),
                        PathNode.QuadTo(1045.7f, 538.6f, 1045.7f, 552.2f),
                        PathNode.Close,
                        PathNode.MoveTo(1045.7f, 874.0f),
                        PathNode.VerticalTo(901.3f),
                        PathNode.QuadTo(1045.7f, 914.9f, 1037.9f, 920.8f),
                        PathNode.QuadTo(1030.2f, 926.7f, 1017.8f, 926.7f),
                        PathNode.HorizontalTo(532.3f),
                        PathNode.QuadTo(520.7f, 926.7f, 512.5f, 920.3f),
                        PathNode.QuadTo(504.4f, 913.9f, 504.4f, 902.3f),
                        PathNode.VerticalTo(874.9f),
                        PathNode.QuadTo(504.4f, 861.4f, 512.1f, 855.0f),
                        PathNode.QuadTo(519.7f, 848.7f, 532.3f, 848.7f),
                        PathNode.HorizontalTo(1017.8f),
                        PathNode.QuadTo(1030.2f, 848.7f, 1037.9f, 854.6f),
                        PathNode.QuadTo(1045.7f, 860.4f, 1045.7f, 874.0f),
                        PathNode.Close,
                        PathNode.MoveTo(1045.7f, 229.4f),
                        PathNode.VerticalTo(256.8f),
                        PathNode.QuadTo(1045.7f, 270.3f, 1038.1f, 276.1f),
                        PathNode.QuadTo(1030.4f, 282.0f, 1017.8f, 282.0f),
                        PathNode.HorizontalTo(532.3f),
                        PathNode.QuadTo(520.5f, 282.0f, 512.5f, 275.6f),
                        PathNode.QuadTo(504.4f, 269.4f, 504.4f, 257.6f),
                        PathNode.VerticalTo(230.2f),
                        PathNode.QuadTo(504.4f, 216.8f, 512.1f, 210.5f),
                        PathNode.QuadTo(519.7f, 204.1f, 532.3f, 204.1f),
                        PathNode.HorizontalTo(1017.8f),
                        PathNode.QuadTo(1030.2f, 204.1f, 1037.9f, 210.0f),
                        PathNode.QuadTo(1045.7f, 215.9f, 1045.7f, 229.4f),
                        PathNode.Close,
                        PathNode.MoveTo(370.2f, 688.6f),
                        PathNode.LineTo(250.9f, 568.3f),
                        PathNode.QuadTo(246.1f, 563.5f, 242.0f, 563.1f),
                        PathNode.QuadTo(237.8f, 562.7f, 232.5f, 568.3f),
                        PathNode.LineTo(182.8f, 617.7f),
                        PathNode.QuadTo(175.6f, 624.9f, 166.1f, 626.2f),
                        PathNode.QuadTo(156.5f, 627.4f, 147.6f, 618.5f),
                        PathNode.LineTo(128.5f, 599.4f),
                        PathNode.QuadTo(118.5f, 589.6f, 119.4f, 580.5f),
                        PathNode.QuadTo(120.4f, 571.4f, 127.6f, 564.3f),
                        PathNode.LineTo(207.7f, 484.0f),
                        PathNode.QuadTo(225.1f, 466.7f, 242.1f, 467.2f),
                        PathNode.QuadTo(259.0f, 467.7f, 279.2f, 486.9f),
                        PathNode.LineTo(426.4f, 634.3f),
                        PathNode.QuadTo(435.5f, 643.4f, 436.0f, 654.0f),
                        PathNode.QuadTo(436.5f, 664.7f, 427.4f, 672.9f),
                        PathNode.LineTo(409.1f, 691.3f),
                        PathNode.QuadTo(399.2f, 700.2f, 389.2f, 698.8f),
                        PathNode.QuadTo(379.2f, 697.4f, 370.2f, 688.6f),
                        PathNode.Close,
                        PathNode.MoveTo(370.2f, 364.9f),
                        PathNode.LineTo(250.9f, 244.6f),
                        PathNode.QuadTo(246.1f, 239.8f, 242.0f, 239.4f),
                        PathNode.QuadTo(237.8f, 239.0f, 232.5f, 244.6f),
                        PathNode.LineTo(182.8f, 294.0f),
                        PathNode.QuadTo(175.6f, 301.2f, 166.1f, 302.4f),
                        PathNode.QuadTo(156.5f, 303.7f, 147.6f, 294.8f),
                        PathNode.LineTo(128.5f, 275.7f),
                        PathNode.QuadTo(118.5f, 265.9f, 119.4f, 256.8f),
                        PathNode.QuadTo(120.4f, 247.7f, 127.6f, 240.5f),
                        PathNode.LineTo(207.7f, 160.3f),
                        PathNode.QuadTo(225.1f, 143.0f, 242.1f, 143.5f),
                        PathNode.QuadTo(259.0f, 144.0f, 279.2f, 163.2f),
                        PathNode.LineTo(426.4f, 310.6f),
                        PathNode.QuadTo(435.5f, 319.7f, 436.0f, 330.3f),
                        PathNode.QuadTo(436.5f, 341.0f, 427.4f, 349.2f),
                        PathNode.LineTo(409.1f, 367.6f),
                        PathNode.QuadTo(399.2f, 376.5f, 389.2f, 375.1f),
                        PathNode.QuadTo(379.2f, 373.7f, 370.2f, 364.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _selectallNormal!!
    }

private var _selectallNormal: ImageVector? = null

val COUIIcons.Regular.SelectAll: ImageVector
    get() {
        if (_selectallRegular != null) return _selectallRegular!!
        _selectallRegular = ImageVector.Builder(
            name = "SelectAll.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1166.4f,
            viewportHeight = 1166.4f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1166.4f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(368.6f, 1011.5f),
                        PathNode.LineTo(254.0f, 895.8f),
                        PathNode.QuadTo(249.1f, 891.0f, 244.9f, 890.6f),
                        PathNode.QuadTo(240.8f, 890.2f, 235.1f, 895.9f),
                        PathNode.LineTo(190.1f, 941.1f),
                        PathNode.QuadTo(182.0f, 949.3f, 171.0f, 950.8f),
                        PathNode.QuadTo(160.0f, 952.2f, 149.8f, 942.1f),
                        PathNode.LineTo(129.8f, 922.1f),
                        PathNode.QuadTo(118.7f, 911.0f, 119.7f, 900.6f),
                        PathNode.QuadTo(120.6f, 890.2f, 128.9f, 881.8f),
                        PathNode.LineTo(207.8f, 802.8f),
                        PathNode.QuadTo(226.6f, 784.3f, 245.1f, 784.7f),
                        PathNode.QuadTo(263.6f, 785.1f, 285.2f, 805.7f),
                        PathNode.LineTo(430.7f, 951.2f),
                        PathNode.QuadTo(440.9f, 961.5f, 441.4f, 973.8f),
                        PathNode.QuadTo(441.8f, 986.1f, 431.7f, 995.3f),
                        PathNode.LineTo(412.7f, 1014.4f),
                        PathNode.QuadTo(401.6f, 1024.5f, 390.1f, 1023.1f),
                        PathNode.QuadTo(378.7f, 1021.6f, 368.6f, 1011.5f),
                        PathNode.Close,
                        PathNode.MoveTo(1047.7f, 553.3f),
                        PathNode.VerticalTo(581.9f),
                        PathNode.QuadTo(1047.7f, 597.1f, 1038.9f, 603.9f),
                        PathNode.QuadTo(1030.1f, 610.7f, 1016.0f, 610.7f),
                        PathNode.HorizontalTo(537.4f),
                        PathNode.QuadTo(524.1f, 610.7f, 515.0f, 603.5f),
                        PathNode.QuadTo(505.9f, 596.1f, 505.9f, 582.8f),
                        PathNode.VerticalTo(554.3f),
                        PathNode.QuadTo(505.9f, 539.1f, 514.6f, 531.8f),
                        PathNode.QuadTo(523.3f, 524.5f, 537.4f, 524.5f),
                        PathNode.HorizontalTo(1016.0f),
                        PathNode.QuadTo(1030.1f, 524.5f, 1038.9f, 531.3f),
                        PathNode.QuadTo(1047.7f, 538.1f, 1047.7f, 553.3f),
                        PathNode.Close,
                        PathNode.MoveTo(1047.7f, 873.9f),
                        PathNode.VerticalTo(902.4f),
                        PathNode.QuadTo(1047.7f, 917.6f, 1038.9f, 924.5f),
                        PathNode.QuadTo(1030.1f, 931.3f, 1016.0f, 931.3f),
                        PathNode.HorizontalTo(537.4f),
                        PathNode.QuadTo(524.1f, 931.3f, 515.0f, 924.0f),
                        PathNode.QuadTo(505.9f, 916.7f, 505.9f, 903.4f),
                        PathNode.VerticalTo(874.8f),
                        PathNode.QuadTo(505.9f, 859.6f, 514.6f, 852.3f),
                        PathNode.QuadTo(523.3f, 845.0f, 537.4f, 845.0f),
                        PathNode.HorizontalTo(1016.0f),
                        PathNode.QuadTo(1030.1f, 845.0f, 1038.9f, 851.8f),
                        PathNode.QuadTo(1047.7f, 858.6f, 1047.7f, 873.9f),
                        PathNode.Close,
                        PathNode.MoveTo(1047.7f, 231.9f),
                        PathNode.VerticalTo(260.4f),
                        PathNode.QuadTo(1047.7f, 275.6f, 1038.9f, 282.4f),
                        PathNode.QuadTo(1030.1f, 289.2f, 1016.0f, 289.2f),
                        PathNode.HorizontalTo(537.4f),
                        PathNode.QuadTo(524.1f, 289.2f, 515.0f, 282.0f),
                        PathNode.QuadTo(505.9f, 274.7f, 505.9f, 261.3f),
                        PathNode.VerticalTo(232.8f),
                        PathNode.QuadTo(505.9f, 217.6f, 514.6f, 210.3f),
                        PathNode.QuadTo(523.3f, 203.0f, 537.4f, 203.0f),
                        PathNode.HorizontalTo(1016.0f),
                        PathNode.QuadTo(1030.1f, 203.0f, 1038.9f, 209.8f),
                        PathNode.QuadTo(1047.7f, 216.6f, 1047.7f, 231.9f),
                        PathNode.Close,
                        PathNode.MoveTo(368.6f, 691.6f),
                        PathNode.LineTo(254.0f, 576.0f),
                        PathNode.QuadTo(249.2f, 571.3f, 245.0f, 570.8f),
                        PathNode.QuadTo(240.8f, 570.3f, 235.1f, 576.0f),
                        PathNode.LineTo(190.1f, 621.2f),
                        PathNode.QuadTo(182.0f, 629.4f, 171.0f, 630.9f),
                        PathNode.QuadTo(160.0f, 632.3f, 149.8f, 622.2f),
                        PathNode.LineTo(129.8f, 602.2f),
                        PathNode.QuadTo(118.7f, 591.1f, 119.7f, 580.7f),
                        PathNode.QuadTo(120.6f, 570.3f, 128.9f, 562.0f),
                        PathNode.LineTo(207.8f, 483.1f),
                        PathNode.QuadTo(226.4f, 464.4f, 245.0f, 464.8f),
                        PathNode.QuadTo(263.6f, 465.2f, 285.2f, 485.9f),
                        PathNode.LineTo(430.7f, 631.5f),
                        PathNode.QuadTo(440.9f, 641.6f, 441.4f, 653.9f),
                        PathNode.QuadTo(441.8f, 666.2f, 431.7f, 675.4f),
                        PathNode.LineTo(412.7f, 694.4f),
                        PathNode.QuadTo(401.6f, 704.6f, 390.1f, 703.1f),
                        PathNode.QuadTo(378.7f, 701.7f, 368.6f, 691.6f),
                        PathNode.Close,
                        PathNode.MoveTo(368.6f, 369.3f),
                        PathNode.LineTo(254.0f, 253.6f),
                        PathNode.QuadTo(249.1f, 248.8f, 244.9f, 248.4f),
                        PathNode.QuadTo(240.8f, 248.0f, 235.1f, 253.8f),
                        PathNode.LineTo(190.1f, 298.9f),
                        PathNode.QuadTo(182.0f, 307.2f, 171.0f, 308.6f),
                        PathNode.QuadTo(160.0f, 310.0f, 149.8f, 299.9f),
                        PathNode.LineTo(129.8f, 279.9f),
                        PathNode.QuadTo(118.7f, 268.8f, 119.7f, 258.4f),
                        PathNode.QuadTo(120.6f, 248.0f, 128.9f, 239.6f),
                        PathNode.LineTo(207.8f, 160.7f),
                        PathNode.QuadTo(226.6f, 142.0f, 245.1f, 142.4f),
                        PathNode.QuadTo(263.6f, 142.7f, 285.2f, 163.5f),
                        PathNode.LineTo(430.7f, 309.0f),
                        PathNode.QuadTo(440.9f, 319.3f, 441.4f, 331.6f),
                        PathNode.QuadTo(441.8f, 343.9f, 431.7f, 353.1f),
                        PathNode.LineTo(412.7f, 372.2f),
                        PathNode.QuadTo(401.6f, 382.3f, 390.1f, 380.9f),
                        PathNode.QuadTo(378.7f, 379.4f, 368.6f, 369.3f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _selectallRegular!!
    }

private var _selectallRegular: ImageVector? = null

val COUIIcons.Medium.SelectAll: ImageVector
    get() {
        if (_selectallMedium != null) return _selectallMedium!!
        _selectallMedium = ImageVector.Builder(
            name = "SelectAll.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1186.2f,
            viewportHeight = 1186.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1186.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(372.7f, 1027.2f),
                        PathNode.LineTo(263.5f, 916.4f),
                        PathNode.QuadTo(258.0f, 911.6f, 254.5f, 911.5f),
                        PathNode.QuadTo(251.0f, 911.4f, 245.3f, 917.1f),
                        PathNode.LineTo(206.2f, 956.9f),
                        PathNode.QuadTo(196.4f, 967.5f, 181.5f, 968.9f),
                        PathNode.QuadTo(166.7f, 970.4f, 154.1f, 957.9f),
                        PathNode.LineTo(134.2f, 937.9f),
                        PathNode.QuadTo(120.7f, 924.4f, 121.6f, 910.8f),
                        PathNode.QuadTo(122.6f, 897.1f, 133.2f, 885.8f),
                        PathNode.LineTo(212.1f, 806.9f),
                        PathNode.QuadTo(233.2f, 786.6f, 255.3f, 786.7f),
                        PathNode.QuadTo(277.3f, 786.8f, 301.3f, 809.8f),
                        PathNode.LineTo(446.7f, 955.2f),
                        PathNode.QuadTo(459.1f, 968.4f, 459.6f, 984.0f),
                        PathNode.QuadTo(460.1f, 999.5f, 447.6f, 1011.1f),
                        PathNode.LineTo(428.6f, 1030.1f),
                        PathNode.QuadTo(415.1f, 1042.6f, 400.2f, 1041.2f),
                        PathNode.QuadTo(385.2f, 1039.7f, 372.7f, 1027.2f),
                        PathNode.Close,
                        PathNode.MoveTo(1065.5f, 563.6f),
                        PathNode.VerticalTo(592.1f),
                        PathNode.QuadTo(1065.5f, 610.8f, 1054.0f, 620.0f),
                        PathNode.QuadTo(1042.5f, 629.2f, 1025.5f, 629.2f),
                        PathNode.HorizontalTo(553.9f),
                        PathNode.QuadTo(537.0f, 629.2f, 525.8f, 619.6f),
                        PathNode.QuadTo(514.6f, 609.9f, 514.6f, 593.0f),
                        PathNode.VerticalTo(564.5f),
                        PathNode.QuadTo(514.6f, 545.7f, 525.7f, 536.1f),
                        PathNode.QuadTo(536.8f, 526.4f, 553.9f, 526.4f),
                        PathNode.HorizontalTo(1025.5f),
                        PathNode.QuadTo(1042.5f, 526.4f, 1054.0f, 535.6f),
                        PathNode.QuadTo(1065.5f, 544.8f, 1065.5f, 563.6f),
                        PathNode.Close,
                        PathNode.MoveTo(1065.5f, 883.8f),
                        PathNode.VerticalTo(912.3f),
                        PathNode.QuadTo(1065.5f, 931.1f, 1054.0f, 940.3f),
                        PathNode.QuadTo(1042.5f, 949.4f, 1025.5f, 949.4f),
                        PathNode.HorizontalTo(553.9f),
                        PathNode.QuadTo(537.0f, 949.4f, 525.8f, 939.8f),
                        PathNode.QuadTo(514.6f, 930.1f, 514.6f, 913.3f),
                        PathNode.VerticalTo(884.8f),
                        PathNode.QuadTo(514.6f, 866.0f, 525.7f, 856.4f),
                        PathNode.QuadTo(536.8f, 846.7f, 553.9f, 846.7f),
                        PathNode.HorizontalTo(1025.5f),
                        PathNode.QuadTo(1042.5f, 846.7f, 1054.0f, 855.9f),
                        PathNode.QuadTo(1065.5f, 865.0f, 1065.5f, 883.8f),
                        PathNode.Close,
                        PathNode.MoveTo(1065.5f, 242.4f),
                        PathNode.VerticalTo(270.9f),
                        PathNode.QuadTo(1065.5f, 289.6f, 1054.0f, 298.8f),
                        PathNode.QuadTo(1042.5f, 308.0f, 1025.5f, 308.0f),
                        PathNode.HorizontalTo(553.9f),
                        PathNode.QuadTo(537.0f, 308.0f, 525.8f, 298.3f),
                        PathNode.QuadTo(514.6f, 288.7f, 514.6f, 271.8f),
                        PathNode.VerticalTo(243.3f),
                        PathNode.QuadTo(514.6f, 224.5f, 525.7f, 214.9f),
                        PathNode.QuadTo(536.8f, 205.2f, 553.9f, 205.2f),
                        PathNode.HorizontalTo(1025.5f),
                        PathNode.QuadTo(1042.5f, 205.2f, 1054.0f, 214.4f),
                        PathNode.QuadTo(1065.5f, 223.6f, 1065.5f, 242.4f),
                        PathNode.Close,
                        PathNode.MoveTo(372.7f, 706.4f),
                        PathNode.LineTo(263.5f, 596.3f),
                        PathNode.QuadTo(258.8f, 591.5f, 254.9f, 591.1f),
                        PathNode.QuadTo(251.0f, 590.6f, 245.3f, 596.3f),
                        PathNode.LineTo(206.2f, 636.1f),
                        PathNode.QuadTo(196.4f, 646.7f, 181.5f, 648.1f),
                        PathNode.QuadTo(166.7f, 649.5f, 154.1f, 637.0f),
                        PathNode.LineTo(134.2f, 617.1f),
                        PathNode.QuadTo(120.7f, 603.6f, 121.6f, 590.0f),
                        PathNode.QuadTo(122.6f, 576.4f, 133.2f, 565.7f),
                        PathNode.LineTo(212.1f, 486.9f),
                        PathNode.QuadTo(232.4f, 465.8f, 254.9f, 465.9f),
                        PathNode.QuadTo(277.3f, 466.0f, 301.3f, 489.7f),
                        PathNode.LineTo(446.7f, 635.1f),
                        PathNode.QuadTo(459.1f, 647.6f, 459.6f, 663.2f),
                        PathNode.QuadTo(460.1f, 678.7f, 447.6f, 690.3f),
                        PathNode.LineTo(428.6f, 709.3f),
                        PathNode.QuadTo(415.1f, 721.8f, 400.2f, 720.3f),
                        PathNode.QuadTo(385.2f, 718.9f, 372.7f, 706.4f),
                        PathNode.Close,
                        PathNode.MoveTo(372.7f, 385.0f),
                        PathNode.LineTo(263.5f, 274.1f),
                        PathNode.QuadTo(258.0f, 269.4f, 254.5f, 269.3f),
                        PathNode.QuadTo(251.0f, 269.2f, 245.3f, 274.9f),
                        PathNode.LineTo(206.2f, 314.7f),
                        PathNode.QuadTo(196.4f, 325.3f, 181.5f, 326.7f),
                        PathNode.QuadTo(166.7f, 328.1f, 154.1f, 315.6f),
                        PathNode.LineTo(134.2f, 295.7f),
                        PathNode.QuadTo(120.7f, 282.2f, 121.6f, 268.6f),
                        PathNode.QuadTo(122.6f, 254.9f, 133.2f, 243.6f),
                        PathNode.LineTo(212.1f, 164.7f),
                        PathNode.QuadTo(233.2f, 143.7f, 255.3f, 143.8f),
                        PathNode.QuadTo(277.3f, 143.9f, 301.3f, 167.6f),
                        PathNode.LineTo(446.7f, 313.0f),
                        PathNode.QuadTo(459.1f, 326.2f, 459.6f, 341.8f),
                        PathNode.QuadTo(460.1f, 357.3f, 447.6f, 368.9f),
                        PathNode.LineTo(428.6f, 387.9f),
                        PathNode.QuadTo(415.1f, 400.3f, 400.2f, 398.9f),
                        PathNode.QuadTo(385.2f, 397.5f, 372.7f, 385.0f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _selectallMedium!!
    }

private var _selectallMedium: ImageVector? = null

val COUIIcons.Demibold.SelectAll: ImageVector
    get() {
        if (_selectallDemibold != null) return _selectallDemibold!!
        _selectallDemibold = ImageVector.Builder(
            name = "SelectAll.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1200.0f,
            viewportHeight = 1200.0f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1200.0f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(375.6f, 1038.2f),
                        PathNode.LineTo(270.2f, 930.7f),
                        PathNode.QuadTo(264.3f, 926.0f, 261.2f, 926.1f),
                        PathNode.QuadTo(258.1f, 926.2f, 252.4f, 931.9f),
                        PathNode.LineTo(217.5f, 967.9f),
                        PathNode.QuadTo(206.4f, 980.2f, 188.9f, 981.6f),
                        PathNode.QuadTo(171.3f, 983.1f, 157.2f, 968.9f),
                        PathNode.LineTo(137.2f, 948.9f),
                        PathNode.QuadTo(122.1f, 933.8f, 123.1f, 917.9f),
                        PathNode.QuadTo(124.0f, 902.1f, 136.3f, 888.6f),
                        PathNode.LineTo(215.1f, 809.8f),
                        PathNode.QuadTo(237.8f, 788.3f, 262.4f, 788.2f),
                        PathNode.QuadTo(286.9f, 788.0f, 312.5f, 812.6f),
                        PathNode.LineTo(457.8f, 957.9f),
                        PathNode.QuadTo(472.0f, 973.3f, 472.4f, 991.1f),
                        PathNode.QuadTo(472.9f, 1008.9f, 458.7f, 1022.1f),
                        PathNode.LineTo(439.7f, 1041.1f),
                        PathNode.QuadTo(424.6f, 1055.2f, 407.2f, 1053.8f),
                        PathNode.QuadTo(389.7f, 1052.4f, 375.6f, 1038.2f),
                        PathNode.Close,
                        PathNode.MoveTo(1077.9f, 570.7f),
                        PathNode.VerticalTo(599.2f),
                        PathNode.QuadTo(1077.9f, 620.4f, 1064.6f, 631.2f),
                        PathNode.QuadTo(1051.3f, 642.1f, 1032.1f, 642.1f),
                        PathNode.HorizontalTo(565.3f),
                        PathNode.QuadTo(546.0f, 642.1f, 533.4f, 630.8f),
                        PathNode.QuadTo(520.7f, 619.5f, 520.7f, 600.1f),
                        PathNode.VerticalTo(571.6f),
                        PathNode.QuadTo(520.7f, 550.4f, 533.5f, 539.1f),
                        PathNode.QuadTo(546.2f, 527.8f, 565.3f, 527.8f),
                        PathNode.HorizontalTo(1032.1f),
                        PathNode.QuadTo(1051.3f, 527.8f, 1064.6f, 538.6f),
                        PathNode.QuadTo(1077.9f, 549.5f, 1077.9f, 570.7f),
                        PathNode.Close,
                        PathNode.MoveTo(1077.9f, 890.8f),
                        PathNode.VerticalTo(919.2f),
                        PathNode.QuadTo(1077.9f, 940.5f, 1064.6f, 951.3f),
                        PathNode.QuadTo(1051.3f, 962.2f, 1032.1f, 962.2f),
                        PathNode.HorizontalTo(565.3f),
                        PathNode.QuadTo(546.0f, 962.2f, 533.4f, 950.8f),
                        PathNode.QuadTo(520.7f, 939.5f, 520.7f, 920.2f),
                        PathNode.VerticalTo(891.7f),
                        PathNode.QuadTo(520.7f, 870.5f, 533.5f, 859.2f),
                        PathNode.QuadTo(546.2f, 847.9f, 565.3f, 847.9f),
                        PathNode.HorizontalTo(1032.1f),
                        PathNode.QuadTo(1051.3f, 847.9f, 1064.6f, 858.7f),
                        PathNode.QuadTo(1077.9f, 869.6f, 1077.9f, 890.8f),
                        PathNode.Close,
                        PathNode.MoveTo(1077.9f, 249.7f),
                        PathNode.VerticalTo(278.2f),
                        PathNode.QuadTo(1077.9f, 299.4f, 1064.6f, 310.2f),
                        PathNode.QuadTo(1051.3f, 321.1f, 1032.1f, 321.1f),
                        PathNode.HorizontalTo(565.3f),
                        PathNode.QuadTo(546.0f, 321.1f, 533.4f, 309.7f),
                        PathNode.QuadTo(520.7f, 298.5f, 520.7f, 279.1f),
                        PathNode.VerticalTo(250.6f),
                        PathNode.QuadTo(520.7f, 229.4f, 533.5f, 218.1f),
                        PathNode.QuadTo(546.2f, 206.8f, 565.3f, 206.8f),
                        PathNode.HorizontalTo(1032.1f),
                        PathNode.QuadTo(1051.3f, 206.8f, 1064.6f, 217.6f),
                        PathNode.QuadTo(1077.9f, 228.5f, 1077.9f, 249.7f),
                        PathNode.Close,
                        PathNode.MoveTo(375.6f, 716.8f),
                        PathNode.LineTo(270.2f, 610.4f),
                        PathNode.QuadTo(265.5f, 605.7f, 261.8f, 605.2f),
                        PathNode.QuadTo(258.1f, 604.7f, 252.4f, 610.4f),
                        PathNode.LineTo(217.5f, 646.5f),
                        PathNode.QuadTo(206.4f, 658.8f, 188.9f, 660.2f),
                        PathNode.QuadTo(171.3f, 661.6f, 157.2f, 647.4f),
                        PathNode.LineTo(137.2f, 627.5f),
                        PathNode.QuadTo(122.1f, 612.4f, 123.1f, 596.5f),
                        PathNode.QuadTo(124.0f, 580.6f, 136.3f, 568.3f),
                        PathNode.LineTo(215.1f, 489.5f),
                        PathNode.QuadTo(236.6f, 466.8f, 261.8f, 466.7f),
                        PathNode.QuadTo(286.9f, 466.6f, 312.5f, 492.4f),
                        PathNode.LineTo(457.8f, 637.7f),
                        PathNode.QuadTo(472.0f, 651.8f, 472.4f, 669.6f),
                        PathNode.QuadTo(472.9f, 687.4f, 458.7f, 700.6f),
                        PathNode.LineTo(439.7f, 719.6f),
                        PathNode.QuadTo(424.6f, 733.8f, 407.2f, 732.4f),
                        PathNode.QuadTo(389.7f, 731.0f, 375.6f, 716.8f),
                        PathNode.Close,
                        PathNode.MoveTo(375.6f, 396.0f),
                        PathNode.LineTo(270.2f, 288.5f),
                        PathNode.QuadTo(264.3f, 283.7f, 261.2f, 283.8f),
                        PathNode.QuadTo(258.1f, 283.9f, 252.4f, 289.6f),
                        PathNode.LineTo(217.5f, 325.7f),
                        PathNode.QuadTo(206.4f, 338.0f, 188.9f, 339.4f),
                        PathNode.QuadTo(171.3f, 340.8f, 157.2f, 326.6f),
                        PathNode.LineTo(137.2f, 306.7f),
                        PathNode.QuadTo(122.1f, 291.6f, 123.1f, 275.7f),
                        PathNode.QuadTo(124.0f, 259.8f, 136.3f, 246.4f),
                        PathNode.LineTo(215.1f, 167.5f),
                        PathNode.QuadTo(237.8f, 144.8f, 262.4f, 144.7f),
                        PathNode.QuadTo(286.9f, 144.6f, 312.5f, 170.4f),
                        PathNode.LineTo(457.8f, 315.7f),
                        PathNode.QuadTo(472.0f, 331.0f, 472.4f, 348.8f),
                        PathNode.QuadTo(472.9f, 366.6f, 458.7f, 379.8f),
                        PathNode.LineTo(439.7f, 398.8f),
                        PathNode.QuadTo(424.6f, 413.0f, 407.2f, 411.6f),
                        PathNode.QuadTo(389.7f, 410.1f, 375.6f, 396.0f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _selectallDemibold!!
    }

private var _selectallDemibold: ImageVector? = null
